import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-modal-fixed-header',
    templateUrl: './modal-fixed-header.component.html',
    styleUrls: ['./modal-fixed-header.component.scss'],
    standalone: false
})
export class ModalFixedHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() passwordChanged: boolean;


  constructor() { }

  ngOnInit(): void {
  }

}
